// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Price = require("../common/Price.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PriceRangeCriteria_priceRange_graphql = require("../../__generated__/PriceRangeCriteria_priceRange_graphql.bs.js");

var convertFragment = PriceRangeCriteria_priceRange_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PriceRangeCriteria_priceRange_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PriceRangeCriteria_priceRange_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PriceRangeCriteria_priceRange_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PriceRangeCriteria_priceRange_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PriceRangeCriteria(props) {
  var match = use(props.priceRange);
  return JsxRuntime.jsx(Price.make, {
              children: match.minPrice.formatted + " - " + match.maxPrice.formatted + (
                props.priceType === "monthly" ? "/month" : ""
              ),
              size: props.size
            });
}

var make = PriceRangeCriteria;

exports.Fragment = Fragment;
exports.make = make;
/* Price Not a pure module */
